!<template>
    <div>
        <div class="modal fade" :id="id_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Log de Autorizaçōes Online</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container" v-if="logAutorizacoes">
                        <div class="row ">
                            <az-input
                                icon="far fa-calendar fa-fw"
                                label="Selecione o Log"
                                placeholder="Selecione o Log"
                                type="select"
                                optionsMode="json"
                                :optionsList="logAutorizacoes"
                                optionsDisplay="created_at"
                                v-model="logAutorizacoesSelecionado">
                            </az-input>
                        </div>
                        <div class="row">
                            <template v-if="logAutorizacoesSelecionado">
                                <div>XML de envio</div>
                                <pre class="alert alert-warning text-wrap w-100">
                                    {{logAutorizacoesSelecionado.st_xml_envio}}
                                </pre>

                                <div>XML de retorno</div>
                                <pre class="alert alert-secondary text-wrap w-100" >
                                    {{logAutorizacoesSelecionado.st_xml_retorno}}
                                </pre>

                                <pre class="alert alert-info" >
                                    {{logAutorizacoesSelecionado.js_retorno}}
                                </pre>
                            </template>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import AzInput from '../forms/AzInput.vue';
import $ from 'jquery';

export default {

    components: {
        AzInput
    },
    
    data() {
        return {
            logAutorizacoes: [],
            logAutorizacoesSelecionado: null,
            id_solicitacao_autorizacao: null
        }
    },

    computed: {
        id_modal() {
            return 'autorizLogModal_' + this.id_solicitacao_autorizacao;
        }
    },

   methods: {

        abrir_modal(solicitacaoAutorizacao) {

            this.logAutorizacoes = [];
            this.logAutorizacoesSelecionado = null;
            this.id_solicitacao_autorizacao = solicitacaoAutorizacao.id_solicitacao_autorizacao;

            this.$util.atualizar(this, {
                service: "solicitacao_autorizacoes",
                func: "log_autorizacoes",
                dados: {
                    id_solicitacao_autorizacao: this.id_solicitacao_autorizacao
                },
                callback: res => {
                    this.logAutorizacoes = res.solicitacao_autorizacao_log;
                    $('#'+this.id_modal).modal('show');
                }
            });
            
            
        },

        fechar_modal() {
            $('#'+this.id_modal).modal('hide');
        }
   }, 
}
</script>
<style>
    
</style>